import { Flex } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import usePatientCaseContent from '@/features/caseCluster/hooks/usePatientCaseContent';
import { MeetingStatsViewContext } from '@/features/meeting-stats/context/MeetingStatsViewContext';
import { PageLoading } from '@/ui/PageLoading';

import LorealPromoterStats from '../../LorealPromoterStats/LorealPromoterStats';

function ChannelDistributionPage() {
  const { meetingID } = useParams();
  const { currentPatientCaseId: currentCase } = useContext(MeetingStatsViewContext);
  const { caseMap, isCaseMapLoading: isCaseLoading } = usePatientCaseContent([currentCase]);

  if (isCaseLoading) {
    return <PageLoading />;
  }
  return (
    <Flex width="100%" marginTop="20px">
      <LorealPromoterStats patientCase={caseMap[currentCase]} meetingID={meetingID} />
    </Flex>
  );
}

export default ChannelDistributionPage;
